import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import UserAvatar from '../../mini/UserAvatar'
import AssignToButton from './AssignToButton'
import UserName from '../../mini/UserName'

import { questIsAssignedToUser } from '../../../utils/assignment'
import { getUserDisplayName } from '../../../utils/name'

export default class AssignedTo extends Component {
  render() {
    const {
      quest,
      user,
      handleAssignClick,
      isQuestCopyEditorOrQuestAuthorOrQuestManager,
      handleUnassignClick
    } = this.props

    return (
      <div id="assignedTo">
        <div className="assigned-to">
          <FormattedMessage
            id={'Quest.Review.AssignmentsArea.AssignedTo'}
            defaultMessage={'Assigned to:'}
          />
        </div>
        <div className="avatar-wrapper">
          <UserAvatar photoUrl={quest.assigned_to.photo_url} />
          <UserName
            activeCertifications={quest.assigned_to.active_certifications}
            userId={`assigned-to-user-${quest.assigned_to.id}`}
            rebuild
          >
            <div className="username">
              {getUserDisplayName(quest.assigned_to)}
            </div>
          </UserName>
        </div>
        {(questIsAssignedToUser(quest, user) ||
          isQuestCopyEditorOrQuestAuthorOrQuestManager) && (
          <React.Fragment>
            <AssignToButton handleClick={handleAssignClick} />
            <div className="unassign link" onClick={handleUnassignClick}>
              Unassign
            </div>
          </React.Fragment>
        )}
      </div>
    )
  }
}

AssignedTo.propTypes = {
  quest: PropTypes.object.isRequired,
  user: PropTypes.object,
  handleAssignClick: PropTypes.func.isRequired,
  handleUnassignClick: PropTypes.func.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/assignment/AssignedTo.js